import { Component, Input, OnInit, input, output } from '@angular/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { OfferModalItem } from '../../../../shared/models/offer-modal-item.model';
import {
  SaComponent,
  CurrencyFormatService,
  OfferStatusPipe
} from 'smartauction-frontend-micro-library';
import { take } from 'rxjs/operators';
import { TranslocoService } from '@jsverse/transloco';
import { DateUtilsService } from 'remarketing-angular-library';
import {
  CollapsableOfferHistoryComponent
} from '../collapsable-offer-history/collapsable-offer-history.component';
import { CommonModule } from '@angular/common';


@Component({
    selector: 'app-multi-offer-history',
    templateUrl: './multi-offer-history.component.html',
    styleUrls: ['./multi-offer-history.component.scss'],
    imports: [CollapsableOfferHistoryComponent, CommonModule, OfferStatusPipe, MatCheckboxModule]
})
export class MultiOfferHistoryComponent extends SaComponent implements OnInit {
  @Input() items: OfferModalItem[] = [];
  @Input() userType: string;
  readonly showSpareKey = input(false);
  readonly platformSpareKeyFee = input<number | undefined>(undefined);
  readonly spareKeySelections = input<Record<string, boolean>>({});
  readonly spareKeyChange = output<{ auctionItemUuid: string; selected: boolean }>();

  CONSTANTS = {
    textVIN: '',
    textDate: '',
    textStatus: '',
    labelSellerOffer: '',
    labelBuyerOffer: '',
    labelViewHistory: '',
    textAddSpareKeyFor: '',
    textSentToBuyingDealership: ''
  };

  constructor(
    private readonly translocoService: TranslocoService,
    private readonly dateUtilService: DateUtilsService,
    private readonly currencyFormatService: CurrencyFormatService
  ) {
    super();
  }

  ngOnInit(): void {
    this.getTranslations();
  }

  getVehicleTitle(item: OfferModalItem) {
    const { modelYear = '', make = '', model = '', trim = '' } = item;
    return `${modelYear} ${make} ${model} ${trim}`;
  }

  formatDate(date) {
    return this.dateUtilService.localizeDate(date);
  }

  formatCurrency(currency, withCents) {
    return this.currencyFormatService.formatCurrency(currency, withCents);
  }

  get offerLabel() {
    return this.userType === 'BUYER' ? this.CONSTANTS.labelSellerOffer : this.CONSTANTS.labelBuyerOffer;
  }

  getTranslations() {
    const keyParams = {
      vehicles: {},
      'UIComponents.sharedListMultiActionModalText': {}
    };

    this.translocoService
      .selectTranslateObject(keyParams)
      .pipe(take(1))
      .subscribe(
        (translate: any[]) => {
          this.CONSTANTS.textVIN = translate[0].offerHistory.textVIN;
          this.CONSTANTS.labelSellerOffer = translate[0].offerHistory.labelSellerOffer;
          this.CONSTANTS.labelBuyerOffer = translate[0].offerHistory.labelBuyerOffer;
          this.CONSTANTS.labelViewHistory = translate[0].offerHistory.labelViewHistory;
          this.CONSTANTS.textDate = translate[0].offerHistory.textDate;
          this.CONSTANTS.textStatus = translate[0].offerHistory.textStatus;
          this.CONSTANTS.textAddSpareKeyFor = translate[1].textAddSpareKeyFor;
          this.CONSTANTS.textSentToBuyingDealership = translate[1].textSentToBuyingDealership;
        },
        error => {
          console.log(error);
        }
      );
  }
}
